import React, { useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';

import { makeStyles } from '@material-ui/core/styles';
import { Button, Grid, Container } from '@material-ui/core';
import auth from 'app/api/auth';

import DialogComponent from 'app/components/DialogComponent';
// import CardInfo from './components/CardInfo';
import Alerts from './components/Alerts';
import Requests from './components/Requests';

import styles from './styles';
import { generatePath, useHistory } from 'react-router-dom';
import FinancialPendencies from './components/FinancialPendencies';
import { URLS } from 'app/config/urls';
import { fetchServices } from 'app/store/slices/services';
import { getLoggedInUser } from 'app/store/slices/user';
import CardInfo from './components/CardInfo';
import { fecthLicenseChangeTypes } from 'app/store/slices/license';
const useStyles = makeStyles(styles);

function Welcome(props) {
  const dispatch = useDispatch();

  const user = useSelector(state => state.auth.user);
  const fromLogin = useSelector(state => state.settings.fromLogin);
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = useState(!user.username);

  const services = useSelector(state => state.services.services);
  const licenseChangeTypes = useSelector(state => state.license.licenseChangeTypes);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (!fromLogin) {
      history.push(URLS.LOGIN);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromLogin]);

  useEffect(() => {
    (async () => {
      const promises = [];
      if (services.summary.length === 0) {
        promises.push(dispatch(fetchServices(user)));
      }
      if (promises.length > 0) {
        await Promise.all(promises);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, user]);

  useEffect(() => {
    const init = async () => {
      if (!!auth.getToken()) {
        try {
          const promises = [];
          promises.push(getLoggedInUser(dispatch));
          if (licenseChangeTypes.length === 0) {
            promises.push(dispatch(fecthLicenseChangeTypes()));
          }
          if (promises.length > 0) {
            await Promise.all(promises);
          }
        } catch (error) {}
      }
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <Container>
      {!user.username && (
        <DialogComponent maxWidth="xs" open={open} onClose={handleClose}>
          <div className={classes.boxFirstAccess}>
            <h2>Bem-vindo!</h2>
            <p>
              <strong>
                Este é o seu primeiro acesso ao portal, por favor solicite o acesso aos serviços.
              </strong>
              <br />
              Clique no link abaixo
            </p>
            <Button
              variant="contained"
              color="primary"
              className={classes.search}
              onClick={() => history.push(generatePath(URLS.SERVICES))}
            >
              Solicitação de acesso
            </Button>
          </div>
        </DialogComponent>
      )}
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <CardInfo />
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={3}>
            {user.username && (
              <>
                <Grid item xs={12} sm={12} md={4} className={classes.containerAlert}>
                  <Grid className={classes.alerts}>
                    <Alerts />
                  </Grid>
                  <Grid>
                    <FinancialPendencies />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={8} className={classes.containerRequest}>
                  <Requests />
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default injectIntl(Welcome);
